<template>
  <div class="aa-bar">
    <div class="aa-bar__group">
      <v-btn
          size="small"
          :variant="currentState === 'normal' ? 'outlined' : 'flat'"
          :color="currentState === 'editionMultiple' ? 'success' : 'primary'"
          prepend-icon="mdi-checkbox-multiple-marked-outline"
          @click="toggleState"
          :text="xs ? null : currentStateText"
          />
      <v-btn
          v-show="areItemsSelected && currentState=='selectionMultiple'"
          size="small"
          color="primary"
          @click="$emit('addItems')"
          :text="xs ? null : $t('actions.send_multiple')"
          prepend-icon="mdi-playlist-check"
          />
      <v-btn
          v-show="areItemsSelected && currentState=='editionMultiple'"
          size="small"
          color="success"
          @click="$emit('addItems')"
          :text="xs ? null : $t('actions.edit_multiple')"
          prepend-icon="mdi-playlist-check"
          />
    </div>
    <div class="aa-bar__group aa-bar__group--right">
      <ReusableDialog
          :value='$t("todos.actions.add_item")'
          :title='$t("todos.actions.add_item")'
          :maxWidth="600"
          :withSave='true'
          @save="saveTodo"
          v-bind:iconXS='"mdi-clipboard-check-multiple"'
          @click='openTodo'
          >
          <template v-slot:content>
              <div class="dlg-context">
                <v-icon size="small" color="primary" class="mr-1">mdi-wind-turbine</v-icon>
                {{ producerName }}
              </div>
              <TodoForm
                  :askProducer='false'
                  :askInterventionReport='false'
                  :askFullfilledAt='false'
                  :stacked='true'
                  ></TodoForm>
          </template>
      </ReusableDialog>
      <ReusableDialog
          ref='intRepButton'
          v-bind:value='$t("verif_machines.actions.add_intervention_report")'
          :title='$t("verif_machines.actions.add_intervention_report")'
          :maxWidth="1100"
          v-bind:iconXS='"mdi-clipboard-file-outline"'
          v-bind:disableBtn='disableAddReport'
          @click = "openIntRep"
          >
          <template v-slot:content>
            <InterventionReportForVerif
                :verif = "verifWithoutReport"
                @saved = "closeIntRep"
                >
            </InterventionReportForVerif>
          </template>
      </ReusableDialog>
      <v-btn
          @click='exportCurrent'
          size='small'
          variant='text'
          :text="xs ? null : $t('verif_machines.actions.export')"
          prepend-icon="mdi-file-pdf-box"
          />
      <v-btn
          v-show='$store.getters.isUserFromStaff'
          @click='requestClosureForYear'
          size='small'
          variant='tonal'
          color="success"
          :text="xs ? null : $t('verif_machines.actions.close_for_year')"
          prepend-icon="mdi-text-box-check-outline"
          />
    </div>
  </div>
</template>
<script>
  import { useDisplay } from "vuetify";
  import { isNone, alertPopup } from "@/functions";
  import i18n from "@/i18n";
  import utils from "@/mixins/utils";
  import ReusableDialog from "@/components/ReusableDialog";
  import TodoForm from '@/components/TodoForm';
  import InterventionReportForVerif from '@/components/maintenance/InterventionReportForVerif';

  export default {
    mixins: [utils],
    components: {
      ReusableDialog,
      TodoForm,
      InterventionReportForVerif,
    },
    props: {
      verifWithoutReport: {},
      areItemsSelected: {},
      producer_id: {},
      someDone: {}
    },
    computed: {
      producerName() {
        const prod = this.$store.state.producers.all.find(a => a.pk == this.producer_id)
        return prod ? prod.display_name : ''
      },
      disableAddReport() {
        return this.verifWithoutReport.length <= 0
      },
    xs() {
      return useDisplay().xs.value
    },
    currentStateText() {
      switch (this.currentState) {
        case 'normal':
          return this.$t('actions.switch.selection_multiple');
        case 'selectionMultiple':
          if (this.someDone) {
          return this.$t('actions.switch.edition_multiple');
          } else {
          return this.$t('actions.switch.normal');
          }
        case 'editionMultiple':
          return this.$t('actions.switch.normal');
        default:
          return 'Unknown State';
      }
    },
  },
    methods: {
      toggleState() {
        switch (this.currentState) {
          case 'normal':
            this.currentState = 'selectionMultiple';
            break;
          case 'selectionMultiple':
            if (this.someDone) {
                this.currentState = 'editionMultiple';
            } else {
                this.currentState = 'normal';
            }
            break;
          case 'editionMultiple':
                this.currentState = 'normal';
            break;
          default:
            this.currentState = 'normal';
        }
        this.$emit('select_multiple', this.currentState);
      },
        openTodo() {
          let prefilled = this.$store.state.todos.struct
          prefilled.assigned_to = this.$store.getters.user
          prefilled.assigned_to_id = this.$store.getters.user.id
          prefilled.producer_id = this.producer_id
          prefilled.producer = this.$store.state.producers.all.find(a => a.pk==this.producer_id)
          this.$store.dispatch("todos/updateEdit", prefilled)
        },
      saveTodo(){
        this.$emit('saveTodo');
      },
        closeIntRep() {
          this.$refs.intRepButton.handleClose();
          this.$store.dispatch('intervention_reports/cleanupEdition');
          this.$emit('reloadVerifDone');
        },
        openIntRep() {
          // to avoid overwriting edition on every conso/aff click
          if (this.$store.state.intervention_reports.edition.cause) return
          let prefilled = this.$store.state.intervention_reports.struct
          prefilled.consumables = [];
          prefilled.affectations = [];
          prefilled.producer_id = this.producer_id
          prefilled.producer = this.$store.state.producers.all.find(a => a.pk==this.producer_id)
          prefilled.status = 'maintenance'
          prefilled.partner_ids = [...new Set(this.verifWithoutReport.flatMap(p => p.last_done_by_ids))]
          prefilled.action = this.$t('verif_machines.annual_maintenance')
          prefilled.cause = this.verifWithoutReport.map(p => '- ' +p.category_name+": " + p.verification_title + '\n')
          prefilled.cause = prefilled.cause.join(' ')
          this.$store.dispatch("intervention_reports/updateEdition", prefilled)
        },
        exportCurrent() {
          this.getFile("verification_reports/export/", "", "application/pdf", "blob", { producer_id: this.producer_id })
        },
        requestClosureForYear() {
          alertPopup(this.$t("verif_reports.close_confirm")).then((result) => {
            if (result) {
              this.$store.dispatch("verif_reports/closeForYear", this.producer_id).then(()=>{
                this.$emit('reloadVerifDone');
                this.$emit('close')
              })
            }
          })
        },
    },
    data() {
      return {
        currentState: 'normal',
      }
    }
}
</script>
<style scoped>
.dlg-context {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  background: #f6f7f9;
  border-radius: 8px;
  padding: 6px 10px;
  margin-bottom: 10px;
}
.aa-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 12px;
}
.aa-bar__group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.aa-bar__group--right {
  margin-left: auto;
}
</style>
